import { Select, chakraComponents } from "chakra-react-select";
import { useEffect, useState } from "react";
import { ClientInterface } from "../interfaces/defaultInterfaces";
import ClientApi from "../services/clientApi";
import bancos from "bancos-brasileiros";

export default function BankSelector({ banco, setBanco }: any) {
  const [clientList, setClientList] = useState(Array<ClientInterface>);
  const [search, setSearch] = useState("");

  const [value, setValue] = useState({
    key: 0,
    value: 0,
    label: "",
  });

  const bancoOptions = bancos.map((banco: any, i: any) => {
    return {
      key: i,
      label: `${banco.COMPE} - ${banco.LongName}`,
      value: banco.COMPE,
    };
  });
  useEffect(() => {
    const temp: any = bancoOptions.find(
      (item: any) => item.value == banco.nroBanco
    );
    setValue(temp);
  }, [banco]);
  function onChangeInput(item: any) {
    setSearch(item);
  }
  function onChangeClientFilter(e: any) {
    setBanco({ ...banco, nroBanco: e.value });
    setValue(e);
  }

  return (
    <>
      <Select
        name="colors"
        chakraStyles={{
          dropdownIndicator: (provided, state) => ({
            ...provided,
            background: "none",
            border: "1px solid black",
            padding: 0,
            w: "20px",
          }),
          control: (base: any) => ({
            // ...base,
            display: "flex",

            borderRadius: "6px",
            background: "white",
            height: "4vh !important",

            fontSize: "1.6vh !important",
          }),
          option: (base: any) => ({
            ...base,
            fontSize: "1.8vh !important",
          }),
        }}
        options={bancoOptions}
        value={value}
        placeholder="Selecione o Banco"
        closeMenuOnSelect={true}
        onChange={(e: any) => {
          onChangeClientFilter(e);
        }}
        onInputChange={(e: any) => {
          onChangeInput(e);
        }}
      ></Select>
    </>
  );
}
